import { render, staticRenderFns } from "./LdFullscreenToggleExpandButton.vue?vue&type=template&id=38dae122&"
import script from "./LdFullscreenToggleExpandButton.vue?vue&type=script&lang=js&"
export * from "./LdFullscreenToggleExpandButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports